<section class="logo-showcase">

    <div class="container-redesign">

        <h2 class="logo-showcase__title">
            Featured <span>Customers & Partners</span>
        </h2>

        <div class="logo-showcase__grid">

            <img src="/assets/img/redesign/partner4.png" alt="Azure">
            <img src="/assets/img/redesign/logo1.png" alt="AWS">
            <img src="/assets/img/redesign/logo2.png" alt="Cloudflare">
            <img src="/assets/img/redesign/logo3.png" alt="OpenAI">
            <img src="/assets/img/redesign/logo5.png" alt="Intel">
            <img src="/assets/img/redesign/logo6.png" alt="Google Cloud">
            <img src="/assets/img/redesign/logo7.png" alt="Lebara">
            <img src="/assets/img/redesign/logo8.png" alt="IONOS">
            <img src="/assets/img/redesign/logo9.png" alt="Microsoft">

        </div>

        <p class="logo-showcase__text">
            Join the Community of Successful Customers and Partners.
        </p>

    </div>

</section>